<script>
import EventBus from "@/EventBus";

export default {
  data() {
    return {
      isOpen: false,
      previousFocus: null,
    };
  },

  mounted() {
    EventBus.$on("mobile-nav", this.onChange);
  },

  methods: {
    onChange(isOpen) {
      this.isOpen = isOpen;

      const bodyEl = document.getElementsByTagName("body")[0];
      bodyEl.style.overflow = this.isOpen ? "hidden" : null;

      if (this.isOpen) {
        // Save focus and move to first link in nav
        this.previousFocus = document.activeElement;
        this.$nextTick(() => {
          if (this.$refs.nav) {
            const firstLink = this.$refs.nav.querySelector("a, button");
            if (firstLink) firstLink.focus();
          }
        });
      } else {
        // Return focus to hamburger button
        if (this.previousFocus && this.previousFocus.focus) {
          this.previousFocus.focus();
          this.previousFocus = null;
        }
      }
    },

    onScreenClick() {
      EventBus.$emit("mobile-nav", false);
    },

    onEscape() {
      if (this.isOpen) {
        EventBus.$emit("mobile-nav", false);
      }
    },

    trapFocus(e) {
      if (!this.isOpen || !this.$refs.nav) return;
      const focusable = this.$refs.nav.querySelectorAll(
        'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    },
  },
};
</script>
